import React, { useCallback, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { langComponent } from "../../constants";
import AppContext from "../../AppContext";

import "../../styles/overlay.scss";

import { ReactComponent as CloseSvg } from "../../assets/auth/login-close.svg";

const Overlay = ({ onClick, children, content, onClose, style = {} }) => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.common);

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUpEvent);
    return () => {
      window.removeEventListener("keyup", handleKeyUpEvent);
    };
  }, [onClose]);

  const handleKeyUpEvent = useCallback(
    ({ key }) => {
      if ((key ?? "") !== "Escape") return;
      onClose();
    },
    [onClose]
  );

  const handleOnClick = (e) => {
    e.stopPropagation();
  };

  const handleBackgroundClick = (e) => {};

  return (
    <div className="overlay" onClick={handleBackgroundClick} style={style}>
      {!content ? (
        <div
          style={{
            display: "flex",
            flexGrow: 1,
            height: "100%",
          }}
          onClick={handleOnClick}
        >
          {children}
        </div>
      ) : (
        <div className="overlay-content" onClick={handleOnClick}>
          <div className="overlay-content-close" onClick={onClose}>
            <CloseSvg />
            <span className="overlay-content-close__text">
              {Translation("Close")}
            </span>
          </div>
          {content}
        </div>
      )}
    </div>
  );
};

Overlay.propTypes = {
  onClick: PropTypes.func,
  content: PropTypes.element,
  onClose: PropTypes.func,
};

Overlay.defaultTypes = { onClick: () => {}, onClose: () => {} };

export default Overlay;
